import { CustomErrorMessage } from '@src/design-system/error-message';
import { Button } from '@src/design-system/button';
import { ErrorMessage, Form } from 'formik';
import { useState } from 'react';
import { DocumentDownload } from 'iconsax-react';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { downloadImportTemplate } from '@src/shared/services/download-template';
import FileUpload from '@src/design-system/molecules/file-upload';
import type { TImportHostFormValues } from '@shared/forms/host';

const ImportHostsForm = ({
  values,
  setFieldValue,
}: {
  values: TImportHostFormValues;
  setFieldValue: (field: string, value: File | null) => void;
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleFileUpload = (file: File | null) => {
    setFieldValue('file', file);
  };

  const handleDownloadTemplate = async () => {
    setIsDownloading(true);
    try {
      await downloadImportTemplate(
        'placement-host-companies/download-import-template/',
        'hosts_import_template'
      );
      toast.success('Template downloaded successfully');
    } catch {
      toast.error('Failed to download template. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Form>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between'>
          <label className='text-gray-800 font-medium text-sm'>
            Upload Multiple Hosts
          </label>
          <Button
            className='h-fit w-fit py-0.5 px-1'
            variant='ghost'
            onClick={handleDownloadTemplate}
            disabled={isDownloading}
          >
            <span className='text-primary-1000 font-medium text-sm underline -mr-1'>
              DOWNLOAD TEMPLATE
            </span>
            {isDownloading ? (
              <Loader2
                size={16}
                className='animate-spin text-primary-1000 w-4! h-4!'
              />
            ) : (
              <DocumentDownload className='text-primary-1000 w-4! h-4!' />
            )}
          </Button>
        </div>
        <FileUpload
          file={values.file as unknown as File}
          name='file'
          onChange={handleFileUpload}
          allowedFormats='.xlsx, .xls, .xlsm, .csv'
          maxSize='800x400px'
          note='Note: You must download and use our template to import hosts.'
        />
        <ErrorMessage
          name='file'
          component={CustomErrorMessage}
        />
      </div>
    </Form>
  );
};

export default ImportHostsForm;
